import React from "react"
import cx from "classnames"
import { observer } from "mobx-react-lite"
import { action } from "mobx"
import { getTileId, Rating } from "../state"

const change = action("Tile.change", (row, index, value) => {
    row.guess[index] = value
})

const Tile = observer(function Tile({appState, row, index}) {

    const  rating = row.rating[index]

    return (
            <input
                id={  getTileId(row.index,index) }
                className={ cx("tile", rating === Rating.PRESENT && "present", rating === Rating.CORRECT && "correct")}
                type="text"
                maxLength={ 1 }
                size={ 1 }
                value={ row.guess[index] }

                onKeyDown={ ev => {
                    if (ev.key === "Enter")
                    {
                        row.cycleRating(index)
                    }
                }}

                onChange={ ev => {
                    row.setValue(index, ev.target.value)

                    if (index < 4 && ev.target.value)
                    {
                        const next = document.getElementById(getTileId(row.index,index + 1))
                        next.focus()
                    }

                } }
            />
    )
})

export default Tile
